<template>
  <div
    class="login-panel flex justify-center flex-col px-24 pb-24 pt-32 bg-white text-center rounded-sm"
  >
    <logo class="block h-24 mb-32" />
    <a
      href="https://www.algolia.com/users/sign_up"
      target="_blank"
      class="mb-32 py-16 px-24 rounded-full bg-nebula-blue hover:bg-neptune-1 text-white no-underline font-semibold leading-tight whitespace-no-wrap"
      @click="
        track({
          message: 'Clicked Sign Up',
          code: 'docs.onboarding.signup',
          extraData: {
            source: 'Tooltip'
          }
        })
      "
      >Sign up</a
    >
    <p>
      or
      <a
        href="https://www.algolia.com/users/sign_in"
        target="_blank"
        class="text-link"
        >login</a
      >
      to automatically see your
      <strong>own credentials</strong>
    </p>
  </div>
</template>

<script>
import Logo from '@/assets/images/logo.svg'

import track from '@/scripts/Track'

export default {
  components: { Logo },
  methods: { track }
}
</script>
